import { Container, Variant } from "@carfax/web-ui/elements/Container";
import { CategoryCard } from "@carfax/web-ui/components/CategoryCard";
import { SectionHeadline } from "@carfax/web-ui/elements/SectionHeadline";
import { useRoutes } from "domain/Routing/hooks/useRoutes";
import { Accordion } from "components/Accessories/Accordion/Accordion";
import { useTranslations } from "next-intl";
import { Icons } from "@carfax/web-ui/elements/Icon";
import { linkUtil } from "utils/i18n/link-util";
import Link from "i18n/components/Link";
import { useLanguage } from "hooks/useLanguage";
import { styles } from "./TermsAndConditionsHubContent.style";

export const TermsAndConditionsHubContent: React.FC = () => {
  const t = useTranslations("page-terms-conditions-hub");
  const routes = useRoutes();

  const language = useLanguage();

  const cards = [
    {
      title: t("termsAndConditionsForPrivateCustomers.title"),
      excerpt: t("termsAndConditionsForPrivateCustomers.excerpt"),
      icon: Icons.websiteUsers,
      href: linkUtil.i18nLinkWithLanguage(routes.termsAndConditions, language),
      linkSeeAllArticlesLabel: t("readMore"),
    },
    {
      title: t("termsAndConditionsForBusinessCustomers.title"),
      excerpt: t("termsAndConditionsForBusinessCustomers.excerpt"),
      icon: Icons.businessCustomers,
      href: linkUtil.i18nLinkWithLanguage(routes.businessTermsAndConditions, language),
      linkSeeAllArticlesLabel: t("readMore"),
    },
  ];

  const cardsMobile = cards.map((item) => ({
    title: item.title,
    body: item.excerpt,
    icon: item.icon,
    iconTitle: item.title,
    linkUrl: item.href,
    linkText: item.linkSeeAllArticlesLabel,
  }));

  return (
    <>
      <Container paddingTop={Variant.Top.Standard}>
        <SectionHeadline headline={t("headline")} isMainHeadline={true} />
        <div className={styles.cards()}>
          {cards.map((card) => {
            const { href, ...rest } = card;

            return (
              <div className={styles.cardWrapper()} key={`termsConditionsCard-${card.title}`}>
                <Link href={href} className={styles.categoryLink()}>
                  <CategoryCard {...rest} />
                </Link>
              </div>
            );
          })}
        </div>
      </Container>
      <div className={styles.cardsMobile()}>
        <Accordion items={cardsMobile} iconFromCMS={true} />
      </div>
    </>
  );
};
